import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/login" element={<LoginPage data-id="element-5" />} data-id="element-4" />
        <Route path="/register" element={<RegisterPage data-id="element-7" />} data-id="element-6" />
        <Route path="/dashboard/*" element={<DashboardPage data-id="element-9" />} data-id="element-8" />
      </Routes>
    </Router>;
}